// extracted by mini-css-extract-plugin
module.exports = {"root":"Login_root__2nxEo","passwordForgot":"Login_passwordForgot__2wBS9","remember":"Login_remember__fjmCq","submit":"Login_submit__12ayN"};